module.exports = __webpack_public_path__ + "img/plaza.db50aea3.svg";